import React, { useRef } from 'react'
import { Link, navigate } from 'gatsby'
import { Tabs, TabPanel, Row } from '@paypalcorp/pp-react'
import { record } from '@paypalcorp/fpti'
import cln from 'classnames'

import { useSectionInViewContext } from '../../../context/SectionInViewContext'

const navItems = [
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Set up accounts',
    url: '#link-setupyouraccounttoacceptcardpayments',
  },
  {
    label: 'Generate token',
    url: '#link-generateclienttoken',
  },
  {
    label: 'Render SDK',
    url: '#link-renderjavascriptsdkandpaypalbuttons',
  },
  {
    label: 'Orders API',
    url: '#link-calltheordersapi',
  },
  {
    label: 'Add cards',
    url: '#link-addcardformelements',
  },
  {
    label: 'Test purchases',
    url: '#link-testpurchases',
  },
]

const intAdvChkItems = [
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Integration video',
    url: '#link-integrationvideo',
  },
  {
    label: 'Before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Before integration',
    url: '#link-beforeyoubeginyourintegration',
  },
  {
    label: 'Back-end code',
    url: '#link-integratebackend',
  },
  {
    label: 'Front-end code',
    url: '#link-integratefrontend',
  },
  {
    label: 'Test integration',
    url: '#link-testintegration',
  },
  {
    label: 'Go Live',
    url: '#link-golive',
  },
]

const navItemsAferPayment = [
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Know before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Seller eligibility',
    url: '#link-sellereligibility',
  },
  {
    label: 'Set up webhooks',
    url: '#link-setupwebhooks',
  },
  {
    label: 'Make Payment',
    url: '#link-makepayment',
  },
  {
    label: 'Send seller signup link',
    url: '#link-sendsellersignuplink',
  },
  {
    label: 'Track seller onboarding status',
    url: '#link-trackselleronboardingstatus',
  },
  {
    label: 'Refund pending transactions',
    url: '#link-refundpendingtransactions',
  },
  {
    label: 'Next steps',
    url: '#link-nextsteps',
  },
]

const navItemsBuildOnboarding = [
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Generate signup link',
    url: '#link-generatesignuplink',
  },
  {
    label: 'Enable signup link',
    url: '#link-embedsignuplink',
  },
  {
    label: 'Redirect seller',
    url: '#link-redirectsellertoareturnurl',
  },
  {
    label: 'Get seller access token',
    url: '#link-getselleraccesstoken',
  },
  {
    label: 'Get seller Rest API credential',
    url: '#link-getsellerrestapicredentials',
  },
  {
    label: 'Next steps',
    url: '#link-nextsteps',
  },
]

const navItemsSDK = [
  {
    label: 'Add the SDK',
    url: '#link-addthesdk',
  },
  {
    label: 'Configure',
    url: '#link-configureandcustomizeyourintegration',
  },
  {
    label: 'Query parameters',
    url: '#link-queryparameters',
  },
  {
    label: 'Script parameters',
    url: '#link-scriptparameters',
  },
]

const navItemsIos = [
  {
    label: 'Know before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Integrate with card payments',
    url: '#link-integratecardpayments',
  },
  {
    label: 'Integrate with PayPal Wallet',
    url: '#link-integratepaypalwallet',
  },
  {
    label: 'Go live',
    url: '#link-golive',
  },
  {
    label: 'Next steps and customizations',
    url: '#link-nextstepsandcustomizations',
  },
]

const navItemsMultiInegrateBefore = [
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Set up webhooks',
    url: '#link-setupwebhooks',
  },
  {
    label: 'Generate signup link',
    url: '#link-generateasignuplink',
  },
  {
    label: 'Add signup link to site',
    url: '#link-addsignuplinktoyoursite',
  },
  {
    label: 'Redirect seller to return URL',
    url: '#link-redirectsellertoareturnurl',
  },
  {
    label: 'Track seller onboarding status',
    url: '#link-trackselleronboardingstatus',
  },
  {
    label: 'Next steps',
    url: '#link-nextsteps',
  },
]

const navItemsStandard = [
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Know before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Add payment buttons',
    url: '#link-addpaymentbuttons',
  },
  {
    label: 'Test purchases',
    url: '#link-testpurchases',
  },
  {
    label: 'Next steps',
    url: '#link-nextsteps',
  },
  {
    label: 'See also',
    url: '#link-seealso',
  },
]

const navItemsAdvanced = [
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Integration video',
    url: '#link-integrationvideo',
  },
  {
    label: 'Before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Before integration',
    url: '#link-beforeyoubeginyourintegration',
  },
  {
    label: 'Back-end code',
    url: '#link-integratebackend',
  },
  {
    label: 'Front-end code',
    url: '#link-integratefrontend',
  },
  {
    label: 'Test integration',
    url: '#link-testintegration',
  },
]

const navItemsApple = [
  {
    label: 'Overview',
    url: '#link-applepayintegration',
  },
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Know before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Setup',
    url: '#link-setupyoursandboxaccounttoacceptapplepay',
  },
  {
    label: 'Getting started',
    url: '#link-gettingstartedinyourtestingenvironment',
  },
  {
    label: 'Integrate ApplePay',
    url: '#link-integrateapplepaycheckout',
  },
  {
    label: 'Button setup',
    url: '#link-setupyourapplepaybutton',
  },
  {
    label: 'Create session',
    url: '#link-createapplepaysession',
  },
  {
    label: 'Payment sheet',
    url: '#link-showthepaymentsheet',
  },
  {
    label: 'Test',
    url: '#link-testyourintegration',
  },
  {
    label: 'Go live',
    url: '#link-golive',
  },
  {
    label: 'Next steps',
    url: '#link-nextstepscustomizations',
  },
]

const navItemsGoogle = [
  {
    label: 'Overview',
    url: '#link-googlepayintegration',
  },
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Know before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Setup',
    url: '#link-setupyoursandboxaccounttoacceptgooglepay',
  },
  {
    label: 'Getting started',
    url: '#link-gettingstartedinyourtestingenvironment',
  },
  {
    label: 'Integrate Google Pay',
    url: '#link-integrategooglepaycheckout',
  },
  {
    label: 'Button setup',
    url: '#link-setupyourgooglepaybutton',
  },
  {
    label: 'Create payment',
    url: '#link-createpaymentdatarequest',
  },
  {
    label: 'Sample integration',
    url: '#link-putitalltogether',
  },
  {
    label: 'SCA',
    url: '#link-strongcustomerauthenticationsca',
  },
  {
    label: 'Test',
    url: '#link-testyourintegration',
  },
  {
    label: 'Go live',
    url: '#link-golive',
  },
  {
    label: 'Next steps',
    url: '#link-nextstepscustomizations',
  },
  {
    label: 'SDK API',
    url: '#link-sdkapireference',
  },
]

export default function NavigationTabs({
  pageName,
  buttonSizes = 'normal',
}: any) {
  const { visibleSection, setVisibleSection } = useSectionInViewContext()
  const fptiData = typeof window !== `undefined` && window.fpti
  const dataSet: any =
    (
      {
        ios: navItemsIos,
        applePay: navItemsApple,
        googlePay: navItemsGoogle,
        sdk: navItemsSDK,
        multiIntegrateBefore: navItemsMultiInegrateBefore,
        integrateStandardCheckout: navItemsStandard,
        integrateAdvancedCheckout: navItemsAdvanced,
        buildOnboarding: navItemsBuildOnboarding,
        afterPayment: navItemsAferPayment,
      } as any
    )[pageName] || navItems

  // const dataSet = pageName === 'ios' ? navItemsIos : navItems
  const selectedIndex = dataSet.findIndex((item) => item.url === visibleSection)

  const handleClick = (value: string) => {
    if (fptiData) {
      record({
        data: {
          page: fptiData.page,
          pgrp: fptiData.page,
          e: 'cl',
          link: value,
        },
      })
    }
  }

  return (
    <div className="navigationWrapper">
      <Tabs
        name="TabsGroup1"
        className={`navTabs-ppui ${
          buttonSizes === 'large' ? 'largeButtons' : ''
        }`}
        selectedTabIdx={selectedIndex}
        tabs={dataSet.map((item) => ({
          label: item.label,
          id: item.url,
          panelId: item.url,
        }))}
        onClick={(e, index) => {
          setVisibleSection(dataSet[index].url)
          handleClick(dataSet[index].label)
          navigate(dataSet[index].url)
        }}
      >
        {dataSet.map((item) => (
          <TabPanel
            key={item.url}
            id={item.url}
            tabId={item.url}
            className="multipartyTabs"
          />
        ))}
      </Tabs>
    </div>
  )
}
